import { useContext, useRef } from "react";
import Form from "react-bootstrap/Form";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";

//Common
import FormBackGround from "../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../common/Forms/FormHeader/FormHeader";
import ActionBar from "../common/ActionBar/ActionBar";
import { CheckboxList } from "../common/VFX-UI";

//App
import { Options } from "../../types";
import { UsersContext } from "./UsersContainer";
import { UserClaimsFormProps } from "../../types/userClaim";

const validationSchema = Yup.object({
  claims: Yup.array()
    .min(1, "Permission is required")
    .required("Permission is required"),
});

const UserPermissionsForm = (props: UserClaimsFormProps) => {
  const { status, initialVal, onClose, handleOnSubmit } = props;
  const formRef = useRef<FormikProps<any>>(null);
  const userContext = useContext(UsersContext);

  let lookupOptions: Options[] = [];
  if (userContext?.permissionsLookupData) {
    lookupOptions = userContext?.permissionsLookupData?.map((item: any) => ({
      value: item.id,
      label: item.display,
    }));
  }

  const saveInput = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };
  const handleCancel = () => {
    if (formRef.current) {
      formRef.current.resetForm();
    }
    onClose();
  };

  return (
    <>
      <div>
        <FormBackGround>
          <FormHeader title={"Permissions"} onClose={onClose} />
          <Formik
            initialValues={{ ...initialVal }}
            enableReinitialize
            innerRef={formRef}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              handleOnSubmit(values);
            }}
          >
            {() => {
              return (
                <Form>
                  <CheckboxList
                    columns={2}
                    label=""
                    name="claims"
                    options={lookupOptions}
                  />
                </Form>
              );
            }}
          </Formik>
        </FormBackGround>
      </div>
      <ActionBar
        cancelHandler={handleCancel}
        submitHandler={saveInput}
        submitText="Save"
        cancelText="Cancel"
        isLoading={status === "pending"}
      />
    </>
  );
};

export default UserPermissionsForm;
